import { Divider, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetOrdersQuery } from "src/api/services/ordersApi";
import { PatientOrder } from "src/api/types";
import TreatmentOverviewSection from "src/components/TreatmentOverviewSection";
import { useLatestPrescription } from "src/context/LatestPrescriptionProvider";
import CareHub from "./components/CareHub";

const Care = () => {
  const page = "care";
  const { t } = useTranslation();
  const { data, isLoading } = useGetOrdersQuery();
  const prescriptionCategory = useLatestPrescription(
    (p) => p.product_category.name,
  );

  const orders = useMemo(() => {
    if (data == null) return [];
    return [
      ...data
        .reduce((acc, order) => {
          if (acc.has(order.product_category.name)) return acc;

          acc.set(order.product_category.name, order);

          return acc;
        }, new Map<string, PatientOrder>())
        .values(),
    ];
  }, [data]);

  const treatments = useMemo(() => {
    return orders
      .map((order, index) => (
        <TreatmentOverviewSection
          order={order}
          page={page}
          key={`${order.invoice_id}-${index}`}
        />
      ))
      .reduce<
        React.ReactNode[] | null
      >((acc, curr, index) => (acc == null ? [curr] : [...acc, <Divider key={`divider-${index}`} />, curr]), null);
  }, [orders]);

  if ((data == null || data.length === 0) && isLoading === false) {
    return prescriptionCategory === "Weight Loss" ? (
      <CareHub />
    ) : (
      <Typography>{t(`${page}.message`)}</Typography>
    );
  }

  return (
    <Stack gap={3}>
      <Typography variant="h5" fontWeight={700}>
        {t(`${page}.header`)}
      </Typography>
      {treatments}
    </Stack>
  );
};

export default Care;
